import { useRef, useState, useMemo } from "react";
import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import styles from "./index.module.scss";
import MembersTable from "./memebrs-table";
import AddMemberModal from "./add-member-modal";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import { mockMembersData } from "./memebrs-table/members.mock-data";
import MembersForm from "./members-form";
import { IMemberFormValues } from "../../../common/validations/members-access.validations";
import ResetPasswordModal from "./reset-password-modal";
import { DistributorFilterDropdown } from "../../SubscriptionBackendPortal/overview/info-tables/distributor-filter-dropdown.component";

const MembersAccessPage = ({ isDistributorView = false }: { isDistributorView?: boolean }) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const initialFormValues: IMemberFormValues = useMemo(() => ({
    members: mockMembersData.map((member) => ({
      name: member.name,
      email: member.email,
      role: Array.isArray(member.role) ? member.role : [member.role],
      status: member.status,
      createdDate: member.createdDate,
      lastLoginDate: member.lastLoginDate,
      authMethod: member.authMethod,
    })),
  }), []);

  const {
    entityData: addMemberModalData,
    setEntityData: setAddMemberModalFlagger,
  } = useEntity<{ show?: boolean } | null>({
    entityType: Flaggers.AddMemberAccessModalFlagger,
  });

  const {
    entityData: resetPasswordModalData,
    setEntityData: setResetPasswordModalFlagger,
  } = useEntity<{ show?: boolean } | null>({
    entityType: Flaggers.ResetPasswordModalFlagger,
  });

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };

  const handleAddMemberClick = () => {
    setAddMemberModalFlagger({ show: true }, FlaggersMethods.UpdateFlagger);
  };

  const handleCloseModal = () => {
    setAddMemberModalFlagger(null, FlaggersMethods.UpdateFlagger);
  };

  const handleCloseResetPasswordModal = () => {
    setResetPasswordModalFlagger(null, FlaggersMethods.UpdateFlagger);
  };

  const handleFormStateChange = (values: IMemberFormValues, isValid: boolean) => {

  };

  return (
    <MembersForm
      initialValues={initialFormValues}
      onFormStateChange={handleFormStateChange}
    >
      {({ values, handleAddRole, handleRemoveRole, handleResetPasswordClick }) => (
        <div className={styles.page}>
          <div className={styles.container}>
            <SearchFilterComponent
              leftSide={
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                  <span className="f-16 line-height-24 f-600 f-black">
                    Members and Access
                  </span>
                  {isDistributorView && <DistributorFilterDropdown />}
                </div>
              }
              searchValue={searchValue}
              searchOnChange={handleSearchOnChange}
              searchOnCross={handleSearchOnCross}
              passedRef={searchInputRef}
              setRef={() => {
                searchInputRef.current?.focus();
              }}
              lastButtonLabel="Add"
              lastButtonOnClick={handleAddMemberClick}
            />
            <MembersTable
              membersData={values.members}
              onAddRole={handleAddRole}
              onRemoveRole={handleRemoveRole}
              onResetPasswordClick={handleResetPasswordClick}
              isDistributorView={isDistributorView}
            />
          </div>

          <AddMemberModal
            isOpen={!!addMemberModalData?.show}
            onClose={handleCloseModal}
          />
          <ResetPasswordModal
            isOpen={!!resetPasswordModalData?.show}
            onClose={handleCloseResetPasswordModal}
          />
        </div>
      )}
    </MembersForm>
  );
};

export default MembersAccessPage;
